import React, { useState, useEffect } from 'react';

const TYPING_SPEED_MS = 35;

const TypewriterText = ({ text, tag: Tag = 'p', className, onComplete, boldRange, reserveSpace }) => {
  const [displayedLength, setDisplayedLength] = useState(0);

  useEffect(() => {
    setDisplayedLength(0);
  }, [text]);

  useEffect(() => {
    if (displayedLength >= text.length) {
      onComplete?.();
      return;
    }
    const timer = setTimeout(() => {
      setDisplayedLength((prev) => Math.min(prev + 1, text.length));
    }, TYPING_SPEED_MS);
    return () => clearTimeout(timer);
  }, [displayedLength, text.length, onComplete]);

  const displayed = text.slice(0, displayedLength);

  let content = displayed;
  if (boldRange && boldRange[0] < displayedLength) {
    const [start, end] = boldRange;
    const before = displayed.slice(0, start);
    const bold = displayed.slice(start, Math.min(end, displayedLength));
    const after = displayed.slice(Math.min(end, displayedLength));
    content = (
      <>
        {before}
        {bold.length > 0 && <strong>{bold}</strong>}
        {after}
      </>
    );
  }

  if (reserveSpace) {
    return (
      <Tag className={`${className} typewriter-reserve`}>
        <span className="typewriter-reserve__placeholder" aria-hidden>{text}</span>
        <span className="typewriter-reserve__visible">{content}</span>
      </Tag>
    );
  }

  return <Tag className={className}>{content}</Tag>;
};

export default TypewriterText;
